// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__2ZqzG"};